import { oidcSettings } from './SettingsManager/settingsManager.js';
import tokenValidator from './TokenManager/tokenValidator.js';
import TokenEventsManager from './TokenManager/tokenEventsManager.js';
import tokenStore from './TokenStore/tokenStore.js';
import SignIn from './SignIn/signIn.js';
import IFrameManager from './IFrameManager/iFrameManager.js';
import SilentRenew from './SilentRenew/silentRenew.js';

const logger = console;
export default class OidcManager {
    constructor(settings) {
        this._settings = settings;
        this._iFrameManager = IFrameManager();

        this.tokenValidator = tokenValidator(settings);
        this.events = new TokenEventsManager(settings);
    }

    _getConfig() {
        return oidcSettings(this._settings);
    }

    _storeTokens(user) {
        logger.log('updating tokens');
        tokenStore.keepAccessToken(user.access_token);
        tokenStore.keepIdToken(user.id_token);
        tokenStore.keepUser(user);
        //Trigger event onSilentAuthSuccess
        var evt = new CustomEvent('onSilentAuthSuccess');
        window.dispatchEvent(evt);
    }

    _onSilentAuthError(error) {
        //Trigger event onSilentAuthError
        var evt = new CustomEvent('onSilentAuthError', {
            detail: {
                errorDetails: error
            }
        });
        window.dispatchEvent(evt);
    }

    silentRenew() {
        tokenStore.forgetToken();
        this._iFrameManager.initSilentRenewListner(this._storeTokens, this._onSilentAuthError);
        return SilentRenew(this._settings);
    }

    silentNotify(code) {
        return new Promise((resolve, reject) => {
            this._getConfig()
                .then((config) => {
                    const signIn = new SignIn(config);
                    signIn.readSignInResponse_v2(code)
                        .then((user) => {
                            if (user && user.access_token) {
                                //SSO TODO Add accessTken Validation
                                // this.tokenValidator.validateTokens(user)
                                //     .then(() => {

                                //         this._iFrameManager.notifyParent(user);
                                //         resolve();
                                //     }, reject);

                                this._iFrameManager.notifyParent(user);
                                resolve();
                                return;
                            }
                            reject(user);
                        }, reject)
                        .catch((err) => {
                            console.log("OidcManager Error while getting acces token: ", err)
                            reject(err);

                        });;
                });
        });
    }
}